import watch from 'redux-watch';
import { getContent, getContentError, isContentReadyOrError } from '../selectors';

// Used to wait for the content to be ready

const contentReady = async store => {
  const watcher = watch(() => isContentReadyOrError(store.getState()));
  return new Promise((resolve, reject) => {
    const unsubscribe = store.subscribe(watcher(() => {
      unsubscribe();
      const error = getContentError(store.getState());
      if (error) {
        reject(error);
      } else {
        resolve(getContent(store.getState()));
      }
    }));
  });
};

export default contentReady;
